module.exports = __webpack_public_path__ + "static/paper-f0a0d49eb08f2df94eb72880805b1f8a.jpg";